module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-5 mt-5",
    style: ({
      backgroundColor: _vm.styles.general.background_color
    }),
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mx-5",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-flex', {
    staticClass: "ml-4 ",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "34px",
      "font-weight": "900"
    }
  }, [_vm._v("Groups")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-4",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "line-height": "120%",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_vm._v("\n          Groups are great for getting things done and staying in touch with just the people you want. Share photos and videos,\n          have conversations, make plans and more.\n        ")])]), _vm._v(" "), _c('v-flex', [_c('v-alert', {
    style: ({
      'background-color': _vm.styles.general.theme_color_dark + '!important'
    }),
    attrs: {
      "icon": "warning",
      "dismissible": "",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n          You cannot access this group as are not a member yet!\n        ")])], 1)], 1), _vm._v(" "), (_vm.privileges.groups && _vm.privileges.groups.create_group) ? _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white my-4",
    staticStyle: {
      "height": "70px",
      "text-transform": "capitalize",
      "float": "right",
      "font-size": "18px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newGroup()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n        Create a Group\n      ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-4 mt-3"
  }, [_c('v-card', {
    staticClass: "mx-5",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "scrollable": false,
      "fixed": ""
    }
  }, [_c('v-tab', {
    staticClass: "mx-2",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n            Groups \n          ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticClass: "mx-2",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n            Your Groups \n          ")], 1)]), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.publicGroups), function(group) {
    return _c('group-view', {
      key: group.groupId,
      attrs: {
        "group": group
      },
      on: {
        "showAlert": _vm.showAlert
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.createdGroups), function(group) {
    return _c('group-view', {
      key: group.groupId,
      attrs: {
        "group": group
      },
      on: {
        "showAlert": _vm.showAlert
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.openCreateGroupModal) ? _c('div', [_c('create-group-modal', {
    attrs: {
      "dialog": _vm.openCreateGroupModal
    },
    on: {
      "update:dialog": function($event) {
        _vm.openCreateGroupModal = $event
      },
      "closeCreateGroupModal": _vm.closeCreateGroupModal
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385be56e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/groupsView.vue
// module id = 1664
// module chunks = 30